import {
    TAKING_CAR_SALE_UPDATE_COMMENT_BEGIN,
    TAKING_CAR_SALE_UPDATE_COMMENT_SUCCESS,
    TAKING_CAR_SALE_UPDATE_COMMENT_FAILURE
  } from '../constants'
  
  export function reducer(state, action) {
    switch (action.type) {
      case TAKING_CAR_SALE_UPDATE_COMMENT_BEGIN:
        return {
          takingCarManagement: {
            ...state.takingCarManagement,
            savePending: true,
            saveSuccess: null,
            saveError: null
          }
        }
      case TAKING_CAR_SALE_UPDATE_COMMENT_SUCCESS:
      const takingCarManagement ={
        ...state.takingCarManagement,
        savePending: false,
        saveError: null,
        saveSuccess: true,
      }
  
      return {
        ...state,
        takingCarManagement
      }
      case TAKING_CAR_SALE_UPDATE_COMMENT_FAILURE:
        return {
          takingCarManagement: {
            ...state.takingCarManagement,
            savePending: false,
            saveSuccess: false,
          }
        }
      default:
        return state
    }
  }
  